<template>
  <div class="admin-container">
    <div class="navbar">
      <router-link class="navbar-item" tag="div" :to="{ path: '/admin/projects' }">
        <span class="mdi mdi-hamburger"></span> Proyectos
      </router-link>
      <router-link class="navbar-item" tag="div" :to="{ path: '/admin/blog' }">
        <span class="mdi mdi-post-outline"></span> Blog
      </router-link>
      <router-link class="navbar-item" tag="div" :to="{ path: '/admin/users' }">
        <span class="mdi mdi-account-circle"></span> Usuarios
      </router-link>
      <router-link class="navbar-item" tag="div" :to="{ path: '/admin/support' }">
        <span class="mdi mdi-help"></span> Ayuda
      </router-link>
      <router-link class="navbar-item" tag="div" :to="{ path: '/admin/notifications' }">
        <span class="mdi mdi-notification-clear-all"></span> Notificaciones
      </router-link>
    </div>
    <div class="mobile-navbar" v-if="showNavMenu">
      <div class="menu-header">
        Menú
        <span class="mdi mdi-close" @click="showNavMenu = false"></span>
      </div>
      <router-link @click.native="showNavMenu = false" class="navbar-item" tag="div" :to="{ path: '/admin/projects' }">
        <span class="mdi mdi-hamburger"></span> Proyectos
      </router-link>
      <router-link @click.native="showNavMenu = false" class="navbar-item" tag="div" :to="{ path: '/admin/blog' }">
        <span class="mdi mdi-post-outline"></span> Blog
      </router-link>
      <router-link @click.native="showNavMenu = false" class="navbar-item" tag="div" :to="{ path: '/admin/users' }">
        <span class="mdi mdi-account-circle"></span> Usuarios
      </router-link>
      <router-link @click.native="showNavMenu = false" class="navbar-item" tag="div" :to="{ path: '/admin/support' }">
        <span class="mdi mdi-help"></span> Ayuda
      </router-link>
      <router-link @click.native="showNavMenu = false" class="navbar-item" tag="div" :to="{ path: '/admin/notifications' }">
        <span class="mdi mdi-notification-clear-all"></span> Notificaciones
      </router-link>
    </div>
    <div class="hamburger-menu" @click="showNavMenu = true">
      <span class="mdi mdi-menu"></span>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <router-view style="margin-bottom: 40px" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('user');
export default {
  data() {
    return {
      showNavMenu: false,
    };
  },
  computed: {
    ...mapState([
      'user',
      'token',
    ]),
  },
  methods: {
    ...mapActions([
      'getUser',
      'logout',
    ]),
  },
  async mounted() {
    try {
      await this.getUser();
      if (!this.user.isAdmin) {
        this.$router.push('/');
      }
    } catch (error) {
      this.$router.push('/');
    }
  },
};
</script>

<style lang="scss" scoped>
.admin-container {
  height: 100vh;
  width: 100vw;
  background-color: #fafcfe;
  padding-top: 70px;
  display: flex;
}
.navbar {
  width: 260px;
  flex-grow: 0;
  height: 100%;
  background-color: white;
  padding: 18px 0;
  //margin-right: 1px solid #f0f2f6;
  box-shadow: 0 0 0 rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.1);
  overflow: hidden;
}
.content-wrapper {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  padding: 40px 0;
  max-height: 100%;
  overflow-y: scroll;
}
.content {
  width: 800px;;
}
.navbar-item {
  font-family: 'Inter';
  padding: 14px 20px;
  color: #3e4b5b;
  cursor: pointer;
  font-weight: 500;

  span {
    margin-right: 10px;
  }
}
.router-link-active {
  color: #3479e9;
}
.menu-header {
  font-size: 20px;
  color: white;
  font-family: 'Inter';
  font-weight: bold;
  padding: 14px 20px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.mobile-navbar {
  display: none;
}
.hamburger-menu {
  position: absolute;
  background-color: #3479e9;
  color: white;
  font-size: 20px;
  padding: 10px;
  border-radius: 50%;
  top: 80px;
  left: 15px;
  display: none;
  z-index: 100;
}
@media only screen and (max-width: 1100px) {
  .navbar {
    width: 0%;
  }
  .mobile-navbar {
    display: block;
    position: absolute;
    width: 50vw;
    height: 100vh;
    background-color: black;
    padding-left: 10px;
    z-index: 1000;

    .navbar-item {
      color: white;
    }
  }
  .hamburger-menu {
    display: block;
  }
}
@media only screen and (max-width: 800px) {
  .content {
    width: 95%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
}
@media only screen and (max-width: 480px) {
  .mobile-navbar {
    width: 100vw;
  }
}
</style>
